import { render } from "./IPs.vue?vue&type=template&id=92231dd0&scoped=true"
import script from "./IPs.vue?vue&type=script&lang=js"
export * from "./IPs.vue?vue&type=script&lang=js"

import "./IPs.vue?vue&type=style&index=0&id=92231dd0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92231dd0"]])

export default __exports__